export const dialogOverrides = { Content: { props: { width: ['540px'] } } };

export const actionsButtonsWidth = ['100%', '180px'];
